module.exports = __webpack_public_path__ + "img/big.5efdf9e0.jpg";